<!--content home-->
<div class="position-relative h-100">
	<img src="assets/media/TILES-BG.png" width="100%" class="object-fit-bg bg-home-bertazzoni" />
	<div class="opaque-layer position-absolute pt-5 mt-3">
		<div class="container">
			<div class="row">
				<div class="col-lg-12 text-white my-4">
					<p class="font-16">
						Welcome
						<span>{{username}}</span>
						,
					</p>
					<div class="d-flex font-12 align-items-center">
						<p class="mb-0 mr-2">
							Aren't you
							<span>{{username}}</span>
							?
						</p>
						<a class="text-underline pb-0 font-italic" routerLink="/logout">Click here to logout</a>
					</div>
				</div>
			</div>
			<span *ngIf="isCliente">
				<div class="row mt-5">
					<div class="order-1 col-lg-2 col-6 mb-4">
						<div class="box-tile bg-white border border-dark text-center" [routerLink]="['/cart']">
							<p class="font-16">My Cart</p>
							<div class="icon">
								<img src="assets/media/cart_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-5 order-lg-2 col-lg-4 col-12 mb-4">
						<div class="box-tile action text-center bg-white border border-dark">
							<p class="ont-16">Shop by Product Code</p>
							<form class="row no-gutters" #formCarrello="ngForm">
								<div class="col-6 pr-2">
									<input
										type="text"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="PRODUCT NUMBER"
										[(ngModel)]="jsonInAddTocart.codiceCommerciale"
										name="codiceCommerciale"
										required />
								</div>
								<div class="col-6 d-flex pl-2">
									<div class="number-input">
										<div (click)="stepQuantita('-')" class="selettore-spin"></div>
										<input
											class="quantity form-bertazzoni"
											min="0"
											max="100"
											name="quantity"
											value="1"
											type="number"
											[(ngModel)]="jsonInAddTocart.quantita"
											required />
										<div (click)="stepQuantita('+')" class="selettore-spin plus"></div>
									</div>
								</div>
								<div class="col-12 text-center mt-4">
									<button
										class="btn btn-bertazzoni black px-5 rounded-0 py-2"
										(click)="shopByCode(scegliProdottoModal)"
										[disabled]="formCarrello.invalid || jsonInAddTocart.quantita == 0">
										ADD TO CART
									</button>
								</div>
							</form>
						</div>
					</div>

					<div class="order-3 order-lg-3 col-lg-2 col-6 mb-4">
						<div class="text-center box-tile bg-white border border-dark" (click)="scrollTo(aCategory)">
							<p class="font-16">Shop by Category</p>
							<div class="icon">
								<img src="assets/media/group_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-4 order-lg-4 col-lg-2 col-6 mb-4">
						<div class="box-tile text-center bg-white border border-dark" (click)="scrollTo(aSeries)">
							<p class="font-16">Shop by Series</p>
							<div class="icon">
								<img src="assets/media/dimond_dark.svg" class="" />
							</div>
						</div>
					</div>

					<div class="order-2 order-lg-5 col-lg-2 col-6 mb-4">
						<div class="text-center box-tile bg-white border border-dark">
							<p class="font-16">Terms & Conditions</p>
							<div class="icon">
								<img src="assets/media/paper_dark.svg" class="" />
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-2 col-6 mb-4">
						<div class="text-center box-tile bg-white border border-dark" [routerLink]="['/orders']">
							<p class="font-16">My Orders</p>
							<div class="icon">
								<img src="assets/media/radio_dark.svg" class="" />
							</div>
						</div>
					</div>
					<!-- <div class="col-lg-2 col-6 mb-4" *ngIf="containerizzazioneAttiva">
						<div class="box-tile text-center bg-white border border-dark" [routerLink]="['/containers']">
							<p class="font-16">Setup your Container</p>
							<div class="icon">
								<img src="assets/media/museum_dark.svg" class="" />
							</div>
						</div>
					</div> -->
					<div class="col-lg-2 col-6 mb-4">
						<div class="box-tile text-center bg-white border border-dark" [routerLink]="['/tracking']">
							<p class="font-16">Tracking</p>
							<div class="icon">
								<img src="assets/media/place_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="col-lg-2 col-6 mb-4">
						<div class="box-tile text-center bg-white border border-dark" [routerLink]="['/profile']">
							<p class="font-16">My Profile</p>
							<div class="icon">
								<img src="assets/media/user_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-12 mb-4">
						<div class="box-tile action text-center bg-white border border-dark">
							<p class="font-16">Change your Password</p>
							<form class="row no-gutters" #form="ngForm">
								<div class="col-12 mb-3">
									<input
										type="password"
										class="form-control form-bertazzoni white rounded-0"
										placeholder="OLD PASSWORD"
										[(ngModel)]="jsonIn.oldPassword"
										name="oldPassword"
										required />
								</div>
								<div class="col-6 pr-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="NEW PASSWORD"
										[(ngModel)]="jsonIn.newPassword"
										name="newPassword"
										required />
								</div>
								<div class="col-6 pl-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="REPEAT PASSWORD"
										[(ngModel)]="jsonIn.newPasswordRepeat"
										name="newPasswordRepeat"
										required />
								</div>
								<span *ngIf="error" class="input-error" [innerHTML]="error"></span>
								<div class="col-12 text-center mt-4">
									<button class="btn btn-bertazzoni black px-5 rounded-0 py-2" (click)="cambioPassword()" [disabled]="form.invalid">
										CHANGE
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</span>
			<span *ngIf="isAdminOrBackoffice">
				<div class="row mt-5">
					<div class="order-1 col-lg-2 col-6 mb-4">
						<div class="box-tile bg-white border border-dark text-center" [routerLink]="['/ordini-cms']">
							<p class="font-16">Order Management</p>
							<div class="icon">
								<img src="assets/media/radio_dark.svg" class="" />
							</div>
						</div>
					</div>

					<div class="order-3 order-lg-3 col-lg-2 col-6 mb-4" *ngIf="isAdmin">
						<div class="text-center box-tile bg-white border border-dark" [routerLink]="['/configurazione-cliente']">
							<p class="font-16">Customer Configuration</p>
							<div class="icon">
								<img src="assets/media/group_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-4 order-lg-4 col-lg-2 col-6 mb-4" *ngIf="isAdmin">
						<div class="box-tile text-center bg-white border border-dark" [routerLink]="['/configurazione-utente']">
							<p class="font-16">Portal User Configuration</p>
							<div class="icon">
								<img src="assets/media/group_dark.svg" class="" />
							</div>
						</div>
					</div>

					<div class="order-2 order-lg-5 col-lg-2 col-6 mb-4">
						<div class="text-center box-tile bg-white border border-dark" [routerLink]="['/profile']">
							<p class="font-16">Profile</p>
							<div class="icon">
								<img src="assets/media/user_dark.svg" class="" />
							</div>
						</div>
					</div>

					<div class="order-5 order-lg-5 col-lg-4 col-12 mb-4">
						<div class="box-tile action text-center bg-white border border-dark">
							<p class="font-16">Change your Password</p>
							<form class="row no-gutters" #form="ngForm">
								<div class="col-12 mb-3">
									<input
										type="password"
										class="form-control form-bertazzoni white rounded-0"
										placeholder="OLD PASSWORD"
										[(ngModel)]="jsonIn.oldPassword"
										name="oldPassword"
										required />
								</div>
								<div class="col-6 pr-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="NEW PASSWORD"
										[(ngModel)]="jsonIn.newPassword"
										name="newPassword"
										required />
								</div>
								<div class="col-6 pl-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="REPEAT PASSWORD"
										[(ngModel)]="jsonIn.newPasswordRepeat"
										name="newPasswordRepeat"
										required />
								</div>
								<span *ngIf="error" class="input-error" [innerHTML]="error"></span>
								<div class="col-12 text-center mt-4">
									<button class="btn btn-bertazzoni black px-5 rounded-0 py-2" (click)="cambioPassword()" [disabled]="form.invalid">
										CHANGE
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</span>

			<span *ngIf="isPartner">
				<div class="row mt-5">
					<div class="col-lg-2 col-6 mb-4">
						<div class="box-tile text-center bg-white border border-dark" [routerLink]="['/tracking']">
							<p class="font-16">Tracking</p>
							<div class="icon">
								<img src="assets/media/place_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-2 order-lg-5 col-lg-2 col-6 mb-4">
						<div class="text-center box-tile bg-white border border-dark" [routerLink]="['/profile']">
							<p class="font-16">Profilo</p>
							<div class="icon">
								<img src="assets/media/user_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-5 order-lg-5 col-lg-4 col-12 mb-4">
						<div class="box-tile action text-center bg-white border border-dark">
							<p class="font-16">Change your Password</p>
							<form class="row no-gutters" #form="ngForm">
								<div class="col-12 mb-3">
									<input
										type="password"
										class="form-control form-bertazzoni white rounded-0"
										placeholder="OLD PASSWORD"
										[(ngModel)]="jsonIn.oldPassword"
										name="oldPassword"
										required />
								</div>
								<div class="col-6 pr-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="NEW PASSWORD"
										[(ngModel)]="jsonIn.newPassword"
										name="newPassword"
										required />
								</div>
								<div class="col-6 pl-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="REPEAT PASSWORD"
										[(ngModel)]="jsonIn.newPasswordRepeat"
										name="newPasswordRepeat"
										required />
								</div>
								<span *ngIf="error" class="input-error" [innerHTML]="error"></span>
								<div class="col-12 text-center mt-4">
									<button class="btn btn-bertazzoni black px-5 rounded-0 py-2" (click)="cambioPassword()" [disabled]="form.invalid">
										CHANGE
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</span>

			<span *ngIf="isSpedizioniere">
				<div class="row mt-5">
					<!-- <div class="col-lg-2 col-6 mb-4" *ngIf="containerizzazioneAttiva">
						<div class="box-tile text-center bg-white border border-dark" [routerLink]="['/containers']">
							<p class="font-16">Setup your Container</p>
							<div class="icon">
								<img src="assets/media/museum_dark.svg" class="" />
							</div>
						</div>
					</div> -->
					<div class="order-2 order-lg-5 col-lg-2 col-6 mb-4">
						<div class="text-center box-tile bg-white border border-dark" [routerLink]="['/profile']">
							<p class="font-16">Profile</p>
							<div class="icon">
								<img src="assets/media/user_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-5 order-lg-5 col-lg-4 col-12 mb-4">
						<div class="box-tile action text-center bg-white border border-dark">
							<p class="font-16">Change your Password</p>
							<form class="row no-gutters" #form="ngForm">
								<div class="col-12 mb-3">
									<input
										type="password"
										class="form-control form-bertazzoni white rounded-0"
										placeholder="OLD PASSWORD"
										[(ngModel)]="jsonIn.oldPassword"
										name="oldPassword"
										required />
								</div>
								<div class="col-6 pr-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="NEW PASSWORD"
										[(ngModel)]="jsonIn.newPassword"
										name="newPassword"
										required />
								</div>
								<div class="col-6 pl-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="REPEAT PASSWORD"
										[(ngModel)]="jsonIn.newPasswordRepeat"
										name="newPasswordRepeat"
										required />
								</div>
								<span *ngIf="error" class="input-error" [innerHTML]="error"></span>
								<div class="col-12 text-center mt-4">
									<button class="btn btn-bertazzoni black px-5 rounded-0 py-2" (click)="cambioPassword()" [disabled]="form.invalid">
										CHANGE
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</span>

			<!-- <span *ngIf="isAgente">
				<div class="row mt-5">
					<div class="col-lg-2 col-6 mb-4">
						<div class="box-tile text-center bg-white border border-dark" [routerLink]="['/ordini-agente']">
							<p class="font-16">Gestione ordini</p>
							<div class="icon">
								<img src="assets/media/radio_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-2 order-lg-5 col-lg-2 col-6 mb-4">
						<div class="text-center box-tile bg-white border border-dark" [routerLink]="['/profile']">
							<p class="font-16">Profile</p>
							<div class="icon">
								<img src="assets/media/user_dark.svg" class="" />
							</div>
						</div>
					</div>
					<div class="order-5 order-lg-5 col-lg-4 col-12 mb-4">
						<div class="box-tile action text-center bg-white border border-dark">
							<p class="font-16">Change your Password</p>
							<form class="row no-gutters" #form="ngForm">
								<div class="col-12 mb-3">
									<input
										type="password"
										class="form-control form-bertazzoni white rounded-0"
										placeholder="OLD PASSWORD"
										[(ngModel)]="jsonIn.oldPassword"
										name="oldPassword"
										required />
								</div>
								<div class="col-6 pr-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="NEW PASSWORD"
										[(ngModel)]="jsonIn.newPassword"
										name="newPassword"
										required />
								</div>
								<div class="col-6 pl-2">
									<input
										type="password"
										class="form-control rounded-0 form-bertazzoni white"
										placeholder="REPEAT PASSWORD"
										[(ngModel)]="jsonIn.newPasswordRepeat"
										name="newPasswordRepeat"
										required />
								</div>
								<span *ngIf="error" class="input-error" [innerHTML]="error"></span>
								<div class="col-12 text-center mt-4">
									<button class="btn btn-bertazzoni black px-5 rounded-0 py-2" (click)="cambioPassword()" [disabled]="form.invalid">
										CHANGE
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</span> -->
		</div>
	</div>
</div>
<div class="bg-black py-5" #aCategory>
	<div class="container">
		<div class="row padding-ampio border-top">
			<div class="text-center my-4 mx-auto text-white">
				<h1 class="titolo-bertazzoni mb-2 pt-4">Shop by Category</h1>
				<p class="didascalia-bertazzoni">
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam facilis, nostrum et eveniet fugit.
				</p>
			</div>
		</div>
		<div class="row border-bottom">
			<div
				class="col-md-4 col-6 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/category'"
				[queryParams]="{q: 'MC_P-CodLineaProdotto|05'}">
				<div class="home-category-img">
					<img src="assets/media/products/rangers.png" width="100%" class="" />
				</div>
				<p class="didascalia-bertazzoni categorie-home" translate>MC_P-CodLineaProdotto|05</p>
			</div>
			<div
				class="col-md-4 col-6 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/category'"
				[queryParams]="{q: 'MC_P-CodLineaProdotto|15'}">
				<div class="home-category-img">
					<img src="assets/media/products/ovens.jpg" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home" translate>MC_P-CodLineaProdotto|15</p>
			</div>
			<div
				class="col-md-4 col-6 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/category'"
				[queryParams]="{q: 'MC_P-CodLineaProdotto|10'}">
				<div class="home-category-img">
					<img src="assets/media/products/cooktops.jpg" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home" translate>MC_P-CodLineaProdotto|10</p>
			</div>
			<div
				class="col-md-4 col-6 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/category'"
				[queryParams]="{q: 'MC_P-CodLineaProdotto|80'}">
				<div class="home-category-img">
					<img src="assets/media/products/ventilations.png" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home" translate>MC_P-CodLineaProdotto|80</p>
			</div>
			<div
				class="col-md-4 col-6 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/category'"
				[queryParams]="{q: 'MC_P-CodLineaProdotto|25'}">
				<div class="home-category-img">
					<img src="assets/media/products/refrigeration.png" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home" translate>MC_P-CodLineaProdotto|25</p>
			</div>
			<div
				class="col-md-4 col-6 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/category'"
				[queryParams]="{q: 'MC_P-CodLineaProdotto|45'}">
				<div class="home-category-img">
					<img src="assets/media/products/dishwasher.png" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home" translate>MC_P-CodLineaProdotto|45</p>
			</div>
		</div>

		<div class="row" #aSeries>
			<div class="col-12">
				<div class="text-center my-5 mx-auto text-white font-20">
					<h1 class="titolo-bertazzoni mb-2 pt-4">Shop by Series</h1>
					<p class="didascalia-bertazzoni">
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam facilis, nostrum et eveniet fugit.
					</p>
				</div>
			</div>
		</div>

		<div class="row padding-ampio border-bottom pt-5">
			<div
				class="col-md-4 col-12 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/series'"
				[queryParams]="{q: 'MC_P-Cod.Serie1|+0609;MC_P-Cod.Serie1|+1099;MC_P-Cod.Serie1|+1599;MC_P-Cod.Serie1|+2599;MC_P-Cod.Serie1|+4599;MC_P-Cod.Serie1|+8099'}">
				<div class="home-category-img">
					<img src="assets/media/products/professional.png" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home">{{'MC_P-Cod.Serie1|+0609' | translate}} Series</p>
			</div>
			<div
				class="col-md-4 col-12 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/series'"
				[queryParams]="{q: 'MC_P-Cod.Serie1|+0604;MC_P-Cod.Serie1|+1101;MC_P-Cod.Serie1|+1601;MC_P-Cod.Serie1|+2600;MC_P-Cod.Serie1|+4601;MC_P-Cod.Serie1|+8101'}">
				<div class="home-category-img">
					<img src="assets/media/products/master.png" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home">{{'MC_P-Cod.Serie1|+0604' | translate}} Series</p>
			</div>
			<div
				class="col-md-4 col-12 text-center text-white mb-5 home-category zoom"
				[routerLink]="'/series'"
				[queryParams]="{q: 'MC_P-Cod.Serie1|+0603;MC_P-Cod.Serie1|+1102;MC_P-Cod.Serie1|+1602;MC_P-Cod.Serie1|+2601;MC_P-Cod.Serie1|+4602;MC_P-Cod.Serie1|+8102'}">
				<div class="home-category-img">
					<img src="assets/media/products/heritage.png" width="100%" />
				</div>
				<p class="didascalia-bertazzoni categorie-home">{{'MC_P-Cod.Serie1|+0603' | translate}} Series</p>
			</div>
		</div>
	</div>
</div>

<ng-template #scegliProdottoModal let-modal>
	<div class="modal-header">
		<h6 class="modal-title" id="">Choose gas type - {{prodottiPerTipoGas[0].codiceCommerciale}}</h6>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div *ngFor="let prodotto of prodottiPerTipoGas" class="mb-2">
			<a (click)="scegliTipoGas(prodotto, modal)">
				<u>{{prodotto.tipoGas}}</u>
			</a>
		</div>
	</div>
</ng-template>
